<template>
    <picture>
        <source type="image/avif" src="@/assets/img/landing/landscape/sky.avif">
        <img alt="" src="@/assets/img/landing/landscape/sky.png" v-bind="$attrs">
    </picture>
</template>
